<template>
  <div id="app" v-if="loaded">
    <div class="gsx-message" v-if="isShow" :class="{'disappear':isHide}">
      <div class="msg-box" :class="{'show':msgStatus}" @click="goOrderList">
        <div class="title">
          <img class="logo" src="./assets/images/m_nav_logo@3x.png" alt="">
          果师兄
        </div>
        <div class="content">
          {{msgText}}
        </div>
      </div>
    </div>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return{
      loaded:false,
      isShow: false,
      msgStatus: true,
      isHide: false,
      msgText: ''
    }
  },
  mounted(){
    var vm = this;
    this.$nextTick(function(){
      vm.loaded = true;
    })

    this.timer = setInterval(function(){
      let access_token = localStorage.access_token
      let expire_time = localStorage.expire_time
      let now = new Date().getTime()
      if(access_token && now < expire_time){
        vm.searchMailBoxMsg()
      }
      
    },5000)
  },
  methods:{
    goOrderList(){
      this.$router.push('orderList')
    },
    searchMailBoxMsg(){
        let access_token = localStorage.access_token
        let info = {
            access_token: access_token,
            app_id: window.config.appid
        }
        this.$store.dispatch('searchMailBoxMsg',info).then((res)=>{
            let result = res.data
            if(result.code == 0){
                let vm = this
                if(result.res.length>0){
                  this.msgText = result.res[0].subject
                  vm.isHide = false
                  vm.isShow = true
                  setTimeout(function(){
                    vm.msgStatus = false
                  },300)

                 setTimeout(function(){
                   vm.isHide = true
                   setTimeout(function(){
                     vm.isShow = false
                   },500)
                 },5000)
                }
            }
        })
    },
  },
  destroyed () {
    clearInterval(this.timer)
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/App.vue